import { getWebTemplate } from "./webRegistry";
import type { TemplateRenderProps } from "./types";
import { normalizeWebFooterVariant } from "./webFooterLayout";
import { resolveWebGlobalLayoutLanguage } from "./webGlobalLayout";
import { siteTemplateRendererCode } from "./templateRendererCode";
import { WebTemplateBlueprintStyles } from "./WebTemplateBlueprintStyles";

export function WebTemplateRenderer(props: TemplateRenderProps) {
    const template = getWebTemplate(siteTemplateRendererCode(props.site));
    const languageCode = props.page?.languageCode ?? "";
    const defaultLanguageCode = (
        props.site?.defaultLanguageCode
        ?? languageCode
    );
    const rawGlobalLayout = (
        props.page?.globalLayout
        ?? props.site?.globalLayout
        ?? null
    );
    const configuredFooter = (
        props.designOverride?.components?.footer
        ?? props.site?.templateDesign?.components?.footer
    );
    const footerVariant = normalizeWebFooterVariant(
        configuredFooter,
        template.manifest.defaults.components?.footer ?? "columns",
    );
    const globalLayout = resolveWebGlobalLayoutLanguage(
        rawGlobalLayout,
        languageCode,
        defaultLanguageCode,
        footerVariant,
    );

    const renderedTemplate = template.render({
        ...props,
        designOverride: props.designOverride ?? props.site?.templateDesign ?? null,
        page: props.page ? {
            ...props.page,
            globalLayout,
        } : props.page,
        site: props.site ? {
            ...props.site,
            globalLayout,
        } : props.site,
    });

    return (
        <>
            <WebTemplateBlueprintStyles
                editorMode={props.editorMode}
                readOnly={props.readOnly}
                templateCode={template.manifest.code}
            />
            {renderedTemplate}
        </>
    );
}
